import {createPortError,safePortCode} from '../platform/port-error.js';

function requireClient(client){
  if(typeof client?.functions?.invoke!=='function'){
    throw new TypeError('Functions client with invoke() is required');
  }
  return client.functions;
}

function abortReason({externalSignal,timedOut}){
  if(externalSignal?.aborted&&!timedOut)return createPortError('ACCOUNT_DELETE_CANCELLED',{cancelled:true});
  return createPortError('ACCOUNT_DELETE_TIMEOUT',{retryable:true,timeout:true});
}

async function providerCode(error){
  try{
    const context=error?.context;
    const payload=context?.clone
      ?await context.clone().json()
      :context?.json
        ?await context.json()
        :null;
    return safePortCode(payload?.code,'ACCOUNT_DELETE_REMOTE_FAILED');
  }catch{
    return 'ACCOUNT_DELETE_REMOTE_FAILED';
  }
}

export function createSupabaseAccountDeletionRemote({
  client,
  functionName='delete-account',
  timeoutMs=15_000
}={}){
  const functions=requireClient(client);
  const name=String(functionName||'').trim();
  if(!name)throw new TypeError('functionName is required');
  const timeout=Math.max(1_000,Math.min(60_000,Number(timeoutMs)||15_000));

  async function deleteAccount({signal}={}){
    if(signal?.aborted)throw createPortError('ACCOUNT_DELETE_CANCELLED',{cancelled:true});
    const controller=new AbortController();
    let timedOut=false;
    const onAbort=()=>controller.abort();
    signal?.addEventListener?.('abort',onAbort,{once:true});
    const timer=setTimeout(()=>{
      timedOut=true;
      controller.abort();
    },timeout);

    try{
      const {data,error}=await functions.invoke(name,{method:'POST',signal:controller.signal});
      if(error){
        if(controller.signal.aborted)throw abortReason({externalSignal:signal,timedOut});
        const code=await providerCode(error);
        throw createPortError(code,{retryable:code==='ACCOUNT_DELETE_REMOTE_FAILED'});
      }
      if(!data?.ok||data?.deleted!==true){
        throw createPortError(safePortCode(data?.code,'ACCOUNT_DELETE_NOT_CONFIRMED'));
      }
      return Object.freeze({
        ok:true,
        deleted:true,
        removedFiles:Number.isFinite(Number(data.removedFiles))?Number(data.removedFiles):0
      });
    }catch(error){
      if(error?.name==='AbortError'||controller.signal.aborted){
        throw abortReason({externalSignal:signal,timedOut});
      }
      throw error;
    }finally{
      clearTimeout(timer);
      signal?.removeEventListener?.('abort',onAbort);
    }
  }

  return Object.freeze({deleteAccount});
}
